// extracted by mini-css-extract-plugin
export default {"ChartAndDetail":"_2I4qY","Chart":"_1rcAr","Detail":"n71oW","Donut":"_2Gb1p","Value":"_2tU5X","Title":"-GCLu"};